import LoginPage from 'pages/Login';
import DashboardPage from 'pages/Dashboard';
import ConsultaPage from 'pages/Consulta';
import CertificadosPage from 'pages/Certificados';
import ValidacaoPage from 'pages/Validacao';
import VisualizacaoPage from 'pages/Visualizacao';

export const Paths = {
  DASHBOARD: '/',
  LOGIN: '/login',
  CERTIFICADOS: '/certificados',
  CONSULTA: '/consulta',
  VALIDACAO: '/validar/:codigoConsulta?',
  VISUALIZACAO: '/visualizar/:codigoConsulta?',
};

export const routes = [
  {
    path: Paths.CONSULTA,
    exact: true,
    component: ConsultaPage,
  },
  {
    path: Paths.DASHBOARD,
    exact: true,
    component: DashboardPage,
  },
  {
    path: Paths.CERTIFICADOS,
    exact: true,
    component: CertificadosPage,
  },
];

export const publicRoutes = [
  {
    path: Paths.LOGIN,
    exact: true,
    component: LoginPage,
  },
];

export const commonRoutes = [{
  path: Paths.VALIDACAO,
  exact: true,
  component: ValidacaoPage,
}, {
  path: Paths.VISUALIZACAO,
  exact: true,
  component: VisualizacaoPage,
}];

export const PublicHomeRoute = Paths.LOGIN;
export const PrivateHomeRoute = Paths.DASHBOARD;
